<div class="position-relative space-top-custom">
  <div class="container d-xs-flex align-items-xs-center min-height-xs-100vh">
    <div class="bg-img-hero mb-1 clearfix d-none d-xl-block"
         [ngStyle]="{'background-image': 'url(' + bannerImage + ')', 'height': largeImgHeightAndBackgroundPosition[0], 'background-position': largeImgHeightAndBackgroundPosition[1]}"></div>
    <div class="bg-img-hero mb-1 clearfix d-none d-lg-block d-xl-none d-md-block"
         [ngStyle]="{'background-image': 'url(' + bannerImage + ')', 'height': medImgHeightAndBackgroundPosition[0], 'background-position': medImgHeightAndBackgroundPosition[1]}"></div>
    <div class="bg-img-hero mb-1 clearfix d-lg-none d-md-none"
         [ngStyle]="{'background-image': 'url(' + bannerImage + ')', 'height': smallImgHeightAndBackgroundPosition[0], 'background-position': smallImgHeightAndBackgroundPosition[1]}"></div>
    <div class="row py-3">

      <!-- Core Content -->
      <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-8 mb-7 mb-lg-0">
        <!-- Header -->
        <h1>
          <strong>{{parkId}}</strong>&nbsp;
        </h1>
        <div class="h3 responsiveBadge" *ngIf="hasBadge" [innerHTML]="badgeHtml"></div>

        <app-animal-rarities *ngIf="animals" [animalEntries]="animalEntries"></app-animal-rarities>
        <!-- End Header -->
        <div class="mt-3" [innerHTML]="paragraphs[0]">
        </div>

        <!-- Photo Gallery -->
        <div appFancyPhotoGallery [photoGallery]="galleries[0]"></div>
        <!-- End Photo Gallery -->

        <h2 class="mt-4">{{paragraphHeaders[0]}}</h2>
        <div class="mt-3" [innerHTML]="paragraphs[1]">
        </div>

        <div class="mt-5 mb-2">
          <!-- Photo Gallery -->
          <div appFancyPhotoGallery class="text-center"
               [photoGallery]="galleries[1]"></div>

          <h2 class="mt-3">{{paragraphHeaders[1]}}</h2>
          <div class="mt-3" [innerHTML]="paragraphs[2]">
          </div>

          <h2 class="mt-3">{{paragraphHeaders[2]}}</h2>
          <div class="mt-3" [innerHTML]="paragraphs[3]">
          </div>
          <div appFancyPhotoGallery class="text-center" [photoGallery]="galleries[2]"></div>
        </div>
        <h2 class="mt-1" *ngIf="paragraphHeaders[3]">{{paragraphHeaders[3]}}</h2>
        <div class="mt-3" *ngIf="paragraphs[4]" [innerHTML]="paragraphs[4]">
        </div>
        <agm-map [latitude]="mapLat" [longitude]="mapLng" [styles]="googleMapStyles" [zoom]="mobileZoom()">
          <agm-marker *ngIf="isOneSpot"
                      [latitude]="mapLat"
                      [longitude]="mapLng"
                      [iconUrl]="{ url: './assets/svg/flat-icons/pin.svg', scaledSize: { width: 40, height: 40 }, anchor: { x: 20, y: 40 } }"
          ></agm-marker>
          <agm-polygon #agmInstance *ngFor="let park of parkBoundaries"
                       [paths]="park.points"
                       [strokeColor]="park.fillColor"
                       [fillColor]="park.fillColor"
                       [strokeWeight]="5"
                       (polyMouseOver)="onMouseOver(infoWindow, agmInstance, park)"
                       (polyMouseOut)="onMouseOut(infoWindow, park)">

            <agm-info-window [disableAutoPan]="true" [latitude]="park.tooltipOrigin.lat"
                             [longitude]="park.tooltipOrigin.lng" #infoWindow>
              <div>
                                <span class="text-primary mr-3"> {{park.name}}</span>
              </div>
            </agm-info-window>
          </agm-polygon>
        </agm-map>
      </div>
      <!-- End Core Content -->
      <!-- Sidebar -->
      <div *ngIf="isMobile(); else normalCards" class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 mb-7 mb-sm-0">
          <app-facts-box [circleWidths]="mobileCircleWidths" [factsHeader]="factsHeader" [facts]="factSet"></app-facts-box>
        </div>
        <div class="col-md-6">
          <div class="position-sticky" style="top:80px; position: -webkit-sticky">
          <app-trip-list id="mobileTripList"
                         titleString="Book a trip today!"
                         subtitleString="Tours which include a visit to the {{tripListParkName}}:"
                         headerColor="secondary"
                         [height]="mobileTripListHeight"
                         [hasTextShadow]="false"
                         [entries]=tripEntries>
          </app-trip-list>
          </div>
        </div>
        <!-- End Facts Sidebar -->
        <!-- Trip List -->
      </div>
      <ng-template #normalCards>
        <div class="col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4 mb-7 mb-sm-0 ">
          <app-facts-box [circleWidths]="desktopCircleWidths" [facts]="factSet" [factsHeader]="factsHeader"></app-facts-box>
          <!-- End Facts Sidebar -->
          <!-- Safari Sidebar -->
          <div class="position-sticky" style="top:80px; position: -webkit-sticky">
          <app-trip-list
            titleString="Book a trip today!"
            subtitleString="Tours which include a visit to the {{tripListParkName}}:"
            headerColor="secondary"
            [hasTextShadow]="false"
            [entries]=tripEntries>
          </app-trip-list>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="col-12 mt-8">
      <div class="card border-1 bg-dark otherParksCard">
        <h4 class="text-center mb-0">Explore Other Tanzania National Parks</h4>
      </div>
    </div>
    <div id="park-cubes-container"></div>
  </div>
</div>
